import { SalaryStructure, SalaryStructureComponent } from 'components/SalaryStructure/types';
import { statusFiltersMap } from './constants';

/**
 * Filters salary structures based on search query or status.
 *
 * @param structures - Array of SalaryStructure to filter.
 * @param filter - Filter object containing search and/or status.
 * @returns Filtered array of SalaryStructure.
 */
export const filterSalaryStructures = (
  structures: SalaryStructure[],
  filter: { search?: string; status?: string },
): SalaryStructure[] => {
  return structures.filter((structure) => {
    const matchesSearch =
      !filter.search || structure.name.toLowerCase().includes(filter.search.toLowerCase());

    const matchesStatus =
      !filter.status ||
      statusFiltersMap[filter.status] === structure.status ||
      filter.status === 'all';

    return matchesSearch && matchesStatus;
  });
};

const formatFormulaValue = (value: string | undefined): string => {
  if (!value) {
    return '';
  }
  const numericValue = parseFloat(value);
  return numericValue % 1 === 0 ? numericValue.toFixed(0) : numericValue.toFixed(2);
};

export const getSalaryStructureComponentFormulas = (component: SalaryStructureComponent) => {
  if (component.salaryComponent.componentType === 'COMPONENT_TYPE_SPECIAL_ALLOWANCE') {
    return 'Residual Value';
  } else if (component.valueType === 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_CTC') {
    return `${formatFormulaValue(component.formula)}% of CTC`;
  } else if (component.valueType === 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_SA') {
    return `${formatFormulaValue(component.formula)}% of Special Allowance`;
  } else if (component.valueType === 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_BASIC') {
    return `${formatFormulaValue(component.formula)}% of Basic`;
  } else if (component.valueType === 'SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_FIXED') {
    return formatFormulaValue(component.formula);
  } else {
    return formatFormulaValue(component.formula);
  }
};
